import styled from '@emotion/styled';
import { BrandStatus } from '@innovationdepartment/proxima-sdk-axios';
import { colors } from '@innovationdepartment/proxima-ui';
import BrandListIntegrationStatus from 'components/BrandList/BrandListIntegrations/BrandListIntegrationStatus';
import { useFeatureFlag } from 'hooks';
import { type BrandListIntegrationStatusProps, IntegrationType } from 'types/integrations';
import type { Brand } from 'types/stores/brand-store';
import LoggedInAsBrandBadge from 'ui/LoggedInAsBrandBadge';
import Tag from 'ui/Tag';
import BrandOverviewHeaderItem from './BrandOverview.HeaderItem.Container';

const BrandOverviewHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 16px;
`;

type BrandOverviewHeaderProps = {
  integrations: BrandListIntegrationStatusProps['integrations'];
  brand: Brand;
  metaAdAccountId?: string;
  tiktokAdAccountId?: string;
};

const BrandOverviewBrandStatus = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const IntegrationsWrapper = styled.div`
  position: relative;
  gap: 4px;
  display: flex;
`;

const BrandOverviewHeader = ({
  integrations,
  metaAdAccountId,
  tiktokAdAccountId,
  brand
}: BrandOverviewHeaderProps) => {
  const { tiktokIntegration } = useFeatureFlag();

  const { brandId } = brand;

  const isLocked = brand.status === BrandStatus.Locked;

  const integrationsContent = (
    <IntegrationsWrapper>
      <BrandListIntegrationStatus
        includeIndicator
        brandId={brandId as string}
        integrations={integrations}
        type={IntegrationType.Facebook}
        isAdAccountActive={Boolean(metaAdAccountId)}
      />
      <BrandListIntegrationStatus
        includeIndicator
        brandId={brandId as string}
        integrations={integrations}
        type={IntegrationType.Shopify}
      />
      <BrandListIntegrationStatus
        includeIndicator
        brandId={brandId as string}
        integrations={integrations}
        type={IntegrationType.Klaviyo}
      />
      {!!tiktokIntegration && (
        <BrandListIntegrationStatus
          includeIndicator
          brandId={brandId as string}
          integrations={integrations}
          type={IntegrationType.TikTok}
          isAdAccountActive={Boolean(tiktokAdAccountId)}
        />
      )}
    </IntegrationsWrapper>
  );
  return (
    <BrandOverviewHeaderWrapper>
      <LoggedInAsBrandBadge />
      {!!brandId && <BrandOverviewHeaderItem canCopy label="Proxima ID" content={brandId} />}
      <BrandOverviewHeaderItem top={8} label="Integrations" content={integrationsContent} />
      {/* {isLocked && ( */}
      <BrandOverviewBrandStatus>
        <BrandOverviewHeaderItem
          label="Brand status"
          content={
            <Tag
              label={isLocked ? 'Locked' : 'Active'}
              variant="tag1Semibold"
              colors={{
                textColor: isLocked ? colors.red70 : colors.green70,
                bgColor: isLocked ? colors.red20 : colors.green20
              }}
            />
          }
        />
      </BrandOverviewBrandStatus>
      {/* )} */}
    </BrandOverviewHeaderWrapper>
  );
};

export default BrandOverviewHeader;
